import Styled from 'styled-components'

export const Brand = Styled.h1`
`

export const Banner = Styled.div`

margin-bottom: 60px;
height: 290px;

img { 
    width: 100%;
    height: 100%;
    height: 290px;
    object-fit: cover;
}

.carousel-control-prev-icon{
    background-image: none !important;
}

.carousel-control-next-icon{
    background-image: none !important;
}

.carousel-indicators [data-bs-target] {
 background-color: rgba(5, 9, 34, 0.16) !important;
}

.carousel-indicators {
    align-items: center;
    margin-bottom: -52px !important;
}

.carousel-indicators .active {
    background-color: #050922 !important;
    width: 8px !important;
    height: 8px !important;
}

button{
    width: 6px !important;
    height: 6px !important; 
    background-color: #FFFFFF !important;
    border-radius: 100% !important;
}

`

export const CotainerProduct = Styled.div`
`

export const Cashback = Styled.div`
`
export const Space = Styled.div`
`
export const Label = Styled.p`
`
export const Title = Styled.p`
`

/* Desktop: alinha o Container do Bootstrap ao padrão do header (1320/32) */
export const PageWrap = Styled.div`
  @media (min-width: 1024px) {
    .container {
      max-width: 1320px;
      padding-left: 32px;
      padding-right: 32px;
    }
  }
`;

/* Desktop: listagem em 2 colunas (filtros 280px + produtos) */
export const ListingLayout = Styled.div`
  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: 280px minmax(0, 1fr);
    gap: 32px;
    align-items: start;

    .product-grid {
      margin-left: 0;
      margin-right: 0;
    }
    .product-grid .col-6 {
      flex: 0 0 25%;
      max-width: 25%;
      width: 25%;
    }
  }
`;

/* Desktop: alinha o nome da marca ao conteúdo (1320/32) */
export const TitleWrap = Styled.div`
  @media (min-width: 1024px) {
    max-width: 1320px;
    margin: 0 auto;
    padding: 0 32px;

    .px-4 {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
`;